import { render, staticRenderFns } from "./AuditLogItem.vue?vue&type=template&id=42420044"
import script from "./AuditLogItem.vue?vue&type=script&lang=js"
export * from "./AuditLogItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports